import { getVisitIdFromCookie } from "@lib/correlation";

export const hyphenate = (string, regex = /\s/g) => string.replace(regex, "-");

export const hashParamsBrandId = location => {
  const state = { location };

  // Login leaves the site through this URL, so the visit id has to travel in
  // `state` - the cookie may not survive the cross-site redirect back.
  const visitId = getVisitIdFromCookie();

  if (visitId) {
    state.visitId = visitId;
  }

  return window.btoa(JSON.stringify(state));
};
